module.exports = __webpack_public_path__ + "static/media/full_time_tutor_intro_chemistry.846a9a85.jpg";